<template>
  <Carousel v-bind="settings" :breakpoints="breakpoints" :autoplay="2000" :wrap-around="true">
    <Slide v-for="(slide, index) in slides" :key="index">
      <div class="card-cor mx-3">
        <div class="card-cor-wrapper">
          <div class="d-flex flex-column align-content-between">
            <div class="px-4">
              <img :src="slide.image" class="mb-2 img-sociedad" alt="img" width="150" />
            </div>
            <div class="text my-auto">
              <div class="title mb-2">{{ lang == 'en' ? slide.en_title : slide.title }}</div>
              <div>{{ lang == 'en' ? slide.en_text : slide.text }}</div>
            </div>
            <a
              v-show="slide.url"
              :href="slide.url"
              class="btn btn-primary mt-auto"
              style="display: block"
              target="_blank"
              >{{ lang == 'en' ? 'Visit website' : 'Visitar sitio web' }}</a
            >
          </div>
        </div>
      </div>
    </Slide>
    <template #addons>
      <Navigation />
    </template>
  </Carousel>
</template>

<script>
import { Carousel, Navigation, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'
export default {
  name: 'CarouselSociedad',
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  props: {
    lang: {
      type: String,
      default: 'es',
      required: false,
    },
  },
  data() {
    return {
      // carousel settings
      settings: {
        itemsToShow: 1,
        snapAlign: 'center',
      },
      slides: [
        {
          title: 'Termotécnica Coindustrial',
          en_title: 'Termotecnica Coindustrial',
          url: 'https://www.termotecnica.com.co/index.php/es',
          image: '/img/brands/sociedad/recurso_6.png',
          text: 'Conjunto de empresas colombianas, con más de 60 años de experiencia operativa en el desarrollo de actividades de Ingeniería, Suministro, Producción, Construcción, Montaje, Operación, Reparación y Mantenimiento.',
          en_text:
            'Group of Colombian companies, with more than 60 years of operational experience in the development of Engineering, Supply, Production, Construction, Assembly, Operation, Repair and Maintenance activities.',
        },
        {
          title: 'Grupo Eiffage',
          en_title: 'Eiffage Group',
          url: 'https://www.eiffage.com',
          image: '/img/brands/sociedad/recurso_7.png',
          text: 'Con más de 100.000 proyectos en 2019 en Francia y en el extranjero, Eiffage es uno de los líderes europeos en construcción y concesiones. Desarrollan su actividad a través de los negocios de construcción, inmobiliario, urbanismo, obra civil, metalmecánica, vialidad, sistemas energéticos y concesiones.',
          en_text:
            'With more than 100,000 projects in 2019 in France and abroad, Eiffage is one of the European leaders in construction and concessions. They develop their activity through the construction, real estate, urban planning, civil works, metalworking, roads, energy systems and concessions businesses.',
        },
        {
          title: 'Unión para la Infraestructura - UPLI',
          en_title: 'Union for Infrastructure (UPLI for its initials in Spanish)',
          url: 'https://upli.co/sobre-nosotros',
          image: '/img/brands/sociedad/Logo_UPLI.png',
          text: 'Es un gestor profesional de inversiones especializado en activos de infraestructura. Ofrece diferentes vehículos de inversión en la región.',
          en_text:
            'It´s a professional investment manager specializing in infrastructure assets. It offers different investment vehicles in the region.',
        },
        {
          title: 'Astris Finance',
          en_title: 'Astris Finance',
          url: 'https://www.astrisfinance.com',
          image: '/img/brands/sociedad/astris.png',
          text: 'Asesor para la estructuración y recaudación de capital a largo plazo para financiar proyectos complejos y, a menudo, pioneros en mercados emergentes y nuevos sectores.',
          en_text:
            'Advisor for the structuring and raising of long-term capital to finance complex and often pioneering projects in emerging markets and new sectors.',
        },
        {
          title: 'CMA CGM',
          en_title: 'CMA CGM',
          url: 'https://www.cma-cgm.com',
          image: '/img/brands/sociedad/recurso_2.png',
          text: 'Tercera naviera más grande del mundo, miembro de la Asociación Ocean Alliance, conformada junto a Cosco y Evergreen. Actualmente, cuenta con más de 44 terminales.',
          en_text:
            'Third largest shipping company in the world, member of the Ocean Alliance Association, formed together with Cosco and Evergreen. Currently, it has more than 44 terminals.',
        },
        {
          title: 'Puertos, Inversiones y Obras PIO  S.A.S',
          en_title: 'Puertos, Inversiones y Obras PIO S.A.S',
          url: 'http://www.piosas.com/portal/index.php',
          image: '/img/brands/sociedad/recurso_3.png',
          text: 'Organización dedicada a desarrollar, ejecutar y administrar infraestructuras portuarias y servicios logísticos; promover proyectos inmobiliarios de gran envergadura. Actualmente, cuenta con 3 puertos en operación y 2 en desarrollo.',
          en_text:
            'Organization dedicated to developing, executing, and managing port infrastructure and logistic services; promote large-scale real estate projects. Currently, it has 3 ports in operation and 2 in development.',
        },
        {
          title: 'Grupo Santamaría',
          en_title: 'Santamaria Group',
          url: 'https://www.gruposantamaria.co',
          image: '/img/brands/sociedad/recurso_12.png',
          text: 'Empresa con más de 40 años de experiencia especializada en la producción de banano tipo exportación. Tiene 22 fincas distribuidas en los municipios de Carepa, Apartadó y Turbo.',
          en_text:
            'Company with more than 40 years of experience specialized in the production of export-type bananas. It has 22 farms distributed in the municipalities of Carepa, Apartadó and Turbo.',
        },
        {
          title: 'C.I.Unibán S.A.',
          en_title: 'C.I. Uniban S.A.',
          url: 'https://uniban.com/index.php/es',
          image: '/img/brands/sociedad/recurso_9.png',
          text: 'Comercializadora internacional colombiana con más de 50 años en el mercado, lidera la actividad agroindustrial y comercial principalmente de banano, plátano y frutos exóticos del país.',
          en_text:
            'International producer and marketer company with more than 50 years of experience. It leads the agro-industrial and commercial activity mainly of bananas, plantains, and exotic fruits of the country.',
        },
        {
          title: 'C.I. Tropical',
          en_title: 'C.I. Tropical',
          url: '',
          image: '/img/brands/sociedad/tropical.png',
          text: 'Comercializadora Internacional dedicada a la producción y comercio de productos agrícolas desde Urabá, principalmente, banano y frutas exóticas.',
          en_text:
            'International producer and marketer company dedicated to the production and trade of agricultural products from Urabá, mainly bananas and exotic fruits.',
        },
        {
          title: 'C.I.Banafrut S.A.',
          en_title: 'C.I. Banafrut S.A.',
          url: 'http://www.banafrut.com/esp',
          image: '/img/brands/sociedad/logo_banafrut.png',
          text: 'Empresa dedicada a la producción y comercialización de banano y plátano, para el mercado convencional y de Mercado Justo.',
          en_text:
            'Company dedicated to the production and marketing of bananas and plantains, for the conventional market and Fairtrade.',
        },
      ],
      // breakpoints are mobile first
      // any settings not specified will fallback to the carousel settings
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 2,
          snapAlign: 'center',
        },
        860: {
          itemsToShow: 2.5,
          snapAlign: 'center',
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: 'start',
        },
        1910: {
          itemsToShow: 4,
          snapAlign: 'start',
        },
      },
    }
  },
}
</script>
